export const colors = {
  main: '#4831D4',
  accent: '#CCF381',
  white: '#FDFDFD',
  text: '#3D155F',
  node: '#83CD29',
  black: '#0F0F0F',
  gray: '#949494'
}
